// removed by extract-text-webpack-plugin
module.exports = {"root":"show-hero__root","imageContainer":"show-hero__imageContainer","hasTrailer":"show-hero__hasTrailer","image":"show-hero__image","alignBottom":"show-hero__alignBottom","alignCenter":"show-hero__alignCenter","alignTop":"show-hero__alignTop","showRating":"show-hero__showRating","visible":"show-hero__visible","trailer":"show-hero__trailer"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/show-hero/styles.less
// module id = 495
// module chunks = 1